module.exports = __webpack_public_path__ + "img/ico_next.7d03c21d.svg";